import DOMPurify from 'dompurify';
import katex, { type KatexOptions } from 'katex';
import { useMemo } from 'react';

const defaultKatexOptions: KatexOptions = {
  throwOnError: false,
  output: 'html',
};

export interface MathRendererProps {
  content: string;
  className?: string;
}

export default function MathRenderer(props: Readonly<MathRendererProps>) {
  const { content = '', className = '' } = props;

  const parsedContent = useMemo(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(DOMPurify.sanitize(content), 'text/html');

    const latexes = doc.querySelectorAll<HTMLSpanElement>('[data-latex]');

    for (const latexNode of Array.from(latexes)) {
      const latexAttr = latexNode.getAttribute('data-latex');

      if (latexAttr) {
        katex.render(latexAttr, latexNode, defaultKatexOptions);
      }
    }

    return doc.body.innerHTML;
  }, [content]);

  return (
    <div data-renderer className={className} dangerouslySetInnerHTML={{ __html: parsedContent }} />
  );
}
